import './footer/x-footer-scripts';
import './footer/header-scroll';
import './footer/mobile-menu';
import './footer/custom-swiper';
import './footer/custom-aos';
import './footer/accordion-and-slides';
import './footer/logo-carousel';
import './footer/contact-form-popup';
import './footer/lottie-animation';